import PropTypes from 'prop-types';
import { OBSIDIAN } from 'HubStyleTokens/colors';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICloseButton from 'UIComponents/button/UICloseButton';
import UIDialogHeaderImage from 'UIComponents/dialog/UIDialogHeaderImage';
import UIModal from 'UIComponents/dialog/UIModal';
import { H4 } from 'UIComponents/elements/headings';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import Confetti from 'growth-onboarding-confetti/Confetti';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TEST_IDS = {
  CELEBRATION_MODAL: 'celebration-modal',
  CELEBRATION_MODAL_CLOSE_BUTTON: 'celebration-modal-close-button'
};
const CelebrationModal = ({
  title,
  bodyContent,
  onClose,
  testID,
  CTA,
  secondaryCTA,
  width
}) => {
  return /*#__PURE__*/_jsxs(UIModal, {
    centered: true,
    width: width || 638,
    "data-test-id": testID || TEST_IDS.CELEBRATION_MODAL,
    children: [/*#__PURE__*/_jsx(Confetti, {}), /*#__PURE__*/_jsx(UICloseButton, {
      onClick: onClose,
      color: OBSIDIAN,
      "data-test-id": TEST_IDS.CELEBRATION_MODAL_CLOSE_BUTTON
    }), /*#__PURE__*/_jsx(UIDialogHeaderImage, {
      offsetBottom: 0,
      offsetTop: 95,
      children: /*#__PURE__*/_jsx(UIIllustration, {
        alt: I18n.text('altText.greenCheckmark'),
        name: 'success',
        width: 118
      })
    }), /*#__PURE__*/_jsx(H4, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: title
      })
    }), bodyContent, /*#__PURE__*/_jsxs(UIDialogFooter, {
      align: "center",
      children: [CTA, secondaryCTA]
    })]
  });
};
CelebrationModal.propTypes = {
  title: PropTypes.string.isRequired,
  bodyContent: PropTypes.element,
  CTA: PropTypes.element,
  secondaryCTA: PropTypes.element,
  onClose: PropTypes.func.isRequired,
  testID: PropTypes.string,
  screen: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
export default CelebrationModal;